import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

export const MAPPING_CUSTOMER_TYPE_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "CUSTOMER_TYPE",
  menuLabel: "CUSTOMER_TYPE",
  pageLabel: "CUSTOMER_TYPE_TITLE_MAPPING",
  name: "mapping_customer_type",
  path: "customer-types",
  description: "CONF_DESC_MAPPING_CUSTOMER_TYPE",
  model: {
    entityName: "datafeed",
    label: "CUSTOMER_TYPE",
    path: "/api/mapping/customer-types",
    bulkPath: "/api/mapping/customer-types/bulk-updates",
    name: "Customer type",
    attributes: [
      {
        key: "datafeed",
        order: 1,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 2,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 3,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 4,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 5,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "customer_type.short_name",
        order: 6,
        label: "CUSTOMER_TYPE",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/customer-types/?is_unmapped=true",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/mapping/customer-types/connectors/",
        apiParams: {
          page_size: 100,
          ordering: "connector",
        },
        key: "id",
        labelKey: "id",
        label: "CONNECTOR_CODE",
        lookup: "connector",
        allowEmpty: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/customer-types/export" },
    import: { path: "/api/mapping/customer-types/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Input,
        label: "DATA_FEED_CODE",
        key: "datafeed",
      },
      {
        type: ConfigurationFormType.Input,
        key: "connector",
        label: "CONNECTOR_CODE",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/customer-types/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "customer_type",
        label: "CUSTOMER_TYPE",
        labelKey: "short_name",
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "connector",
        flex: "100%",
        readonly: true,
      },
      {
        key: "customer_type",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "customer_type",
        flex: "100%",
      },
    ],
  },
};
